import { useQuery } from "@tanstack/react-query";
import { getApiCodelistManagementFilesVersions } from "Infrastructure/Api/Api";

export const CODELIST_FILE_VERSIONS_QUERY_KEY = "CODELIST_FILE_VERSIONS_QUERY";

export function useCodeListFileVersionsQuery(
	folderPath?: string,
	fileName?: string,
	enabled = true
) {
	return useQuery({
		queryKey: [CODELIST_FILE_VERSIONS_QUERY_KEY, folderPath, fileName],
		queryFn: () => getApiCodelistManagementFilesVersions(folderPath, fileName),
		enabled: enabled && !!folderPath && !!fileName,
	});
}
